
export function msg(key: string, ...args:any): string {
	// @ts-ignore
    let textMap = window.bundle as Map<string, string>;         // Use global map from shared.js.jsp
    let text = textMap.get(key);
    if (text) {
        for (let i = 0; i < args.length; i++) {
            text = text.replaceAll("{" + i + "}", args[i]);
        }
    } else text = key; // not found
    return text;
}
